import React from 'react';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import './ResourcesIframe.css';

const ResourcesIframe = () => {
  const { RESOURCES_IFRAME_EN, RESOURCES_IFRAME_FR } = useSelector(state => state.appConfig);

  const WESTERN_RESOURCES_IFRAME = i18n.language === 'E' ? `${RESOURCES_IFRAME_EN}` : `${RESOURCES_IFRAME_FR}`;

  return (
    <div className="resources-iframe">
      <iframe title="resources BV" src={WESTERN_RESOURCES_IFRAME} />
    </div>
  );
};

export default ResourcesIframe;



// WEBPACK FOOTER //
// ./src/containers/ResourcesIframe/ResourcesIframe.jsx